import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-add-tariff-plan',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './add-tariff-plan.html',
  styleUrls: ['./add-tariff-plan.css']
})
export class AddTariffPlanComponent {
  tariffForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddTariffPlanComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.tariffForm = this.fb.group({
      pricePerKwh: ['', [Validators.required, Validators.min(0)]],
      cgst: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      sgst: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      igst: ['', [Validators.required, Validators.min(0), Validators.max(100)]]
    });
  }

  onSubmit(): void {
    if (this.tariffForm.valid) {
      console.log('Tariff Plan Data:', this.tariffForm.value ,"API call");
      this.dialogRef.close();
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
